import Account from "./Account";

const Employee = {
  Account,
};

export default Employee;
